<template>
  <b-modal
    ref="choose-video-modal"
    id="choose-video-modal"
    class="choose-video-modal"
    size="xl"
    hide-header
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <div
      class="d-flex justify-content-between top-modal"
      style="margin-top: 10px;"
    >
      <div>
        <h4 class="font-medium text-primary">
          Select Video
        </h4>
        <!--        <p class="mb-0 text-placeholder">-->
        <!--          Choose an ad group, then select an ad and videos for its creative list-->
        <!--        </p>-->
      </div>
      <div>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideModal"
        />
      </div>
    </div>
    <div class="choose-video-content mt-1">
      <div class="mb-1">
        <!-- Ad Selection -->
        <div class="d-flex">
          <div class="w-50">
            <div class="d-flex align-items-center justify-content-between">
              <label class="form-label font-weight-bold">Select Ad:</label>
              <div
                v-b-tooltip.hover.top.v-light="'Edit'"
                class="rounded-circle d-flex align-items-center justify-content-center"
                style="background-color: rgba(0, 0, 0, 0.1); width: 24px; height: 24px;"
              >
                <feather-icon
                  size="14"
                  class="cursor-pointer"
                  icon="EditIcon"
                  @click="startEditAdName"
                />
              </div>
            </div>
            <div v-if="isEditAdName === false">
              <v-select
                v-model="selectedAd"
                :options="adOptions"
                label="name"
                class="select-video-input"
                :clearable="false"
                :searchable="false"
                @input="handleChangeAd"
              >
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes">
                    <feather-icon
                      icon="ChevronDownIcon"
                      size="13"
                    />
                  </span>
                </template>
                <template #selected-option="{ name }">
                  <div
                    v-b-tooltip.hover.top.v-light.html
                    class="d-flex flex-column content-ad-account w-100"
                    :title="name ? name : '--'"
                  >
                    <span
                      class="wrap-content"
                      style="margin-right: 4px"
                    >{{ name }}</span>
                  </div>
                </template>
                <template #option="{ name }">
                  <div class="d-flex justify-content-between">
                    <span>{{ name }}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <div v-else>
              <div class="d-flex align-items-center">
                <b-form-input
                  v-model="currentAdName"
                  name="adName"
                  placeholder="Enter Ad name"
                  style="height: 38px; flex: 1;"
                  @keyup.enter="saveAdName"
                  @keyup.esc="cancelAdNameEdit"
                />
                <div class="ml-2 d-flex">
                  <feather-icon
                    class="cursor-pointer mr-1 text-danger"
                    icon="CheckIcon"
                    size="16"
                    @click="saveAdName"
                  />
                  <feather-icon
                    class="cursor-pointer"
                    icon="XIcon"
                    size="16"
                    @click="cancelAdNameEdit"
                  />
                </div>
              </div>
              <small
                v-if="currentAdName === ''"
                class="text-danger d-block"
              >
                Ad name is required
              </small>
            </div>
          </div>
          <div
            v-if="hasLandingPageUrl"
            class="position-relative pl-2 w-50"
          >
            <label class="form-label font-weight-bold">Destination URL:</label>
            <b-form-input
              v-model="destinationUrl"
              name="textName"
              class="input-height"
              style="height: 42px"
              placeholder="Enter text Destination URL"
              @input="handleEnterDestinationUrl"
            />
            <small
              v-if="isValidLandingPageUrl"
              class="text-danger position-absolute"
              style="bottom: -20px"
            >
              {{ isValidLandingPageUrl }}
            </small>
          </div>
        </div>
      </div>
      <b-tabs
        class="tab-video"
        :class="{'hide-tab': !isTikTokPlacement}"
        fill
      >
        <b-tab
          v-if="isTikTokPlacement"
          :active="tab === 'tiktok-posts'"
          @click="onClickTikTokTab"
        >
          <template #title>
            <div class="tab-title d-flex align-items-center">
              TikTok posts
              <p
                v-if="selectedVideosTikTok.length > 0"
                class="selected-number d-flex justify-content-center align-items-center"
              >
                <span>{{ selectedVideosTikTok.length }}</span>
              </p>
            </div>
          </template>
          <select-video-tik-tok-view
            :selected-identity="selectedIdentity"
            :identity-options="identityOptions"
            :is-tik-tok-placement="isTikTokPlacement"
            :selected-videos="selectedVideos"
            :selected-videos-tik-tok="selectedVideosTikTok"
            :loading-video="loadingVideo"
            :all-videos="allVideos"
            :loading-more="loadingMore"
            :has-more="hasMore"
            @on-identity-change="onIdentityChange"
            @fetchListVideo="fetchListVideoTikTok"
            @toggle-video-selection="toggleVideoSelection"
          />
        </b-tab>
        <b-tab
          :active="tab === 'creative-library'"
          @click="tab = 'creative-library'"
        >
          <template #title>
            <div class="tab-title d-flex align-items-center">
              Creative library
              <p
                v-if="selectedVideosCreative.length > 0"
                class="selected-number d-flex justify-content-center align-items-center"
              >
                <span>{{ selectedVideosCreative.length }}</span>
              </p>
            </div>
          </template>
          <select-video-creative-library
            :campaigns="campaigns"
            :current-ad-group="currentAdGroup"
            :selected-ad="selectedAd"
            :identity-options="identityOptions"
            :is-tik-tok-placement="isTikTokPlacement"
            :selected-videos="selectedVideos"
            :selected-videos-creative="selectedVideosCreative"
            :loading-video="loadingVideo"
            :all-videos="allVideosCreative"
            :loading-more="loadingMore"
            :has-more="hasMoreCreative"
            @on-identity-change="onIdentityChange"
            @fetchListVideo="fetchListVideoCreative"
            @toggle-video-selection="toggleVideoSelection"
            @validation-state-changed="onLibraryValidationChange"
            @openSyncHerotiveVideoModal="openSyncHerotiveVideoModal"
          />
        </b-tab>
      </b-tabs>
    </div>

    <!-- Action Buttons -->
    <template #modal-footer>
      <div class="d-flex justify-content-between align-items-center w-100">
        <p>All videos ({{ selectedVideos.length }} selected)</p>
        <div class="d-flex justify-content-end">
          <small
            v-if="messageError"
            class="text-danger d-block mt-25"
          >{{ messageError }}</small>
          <btn-loading
            class="mr-1 border-0"
            variant-convert="btn-back"
            pill
            @click="hideModal"
          >
            Cancel
          </btn-loading>
          <btn-loading
            class="ml-1"
            variant-convert="btn-submit"
            type="submit"
            pill
            :disabled="!selectedAd || selectedVideos.length === 0 || messageError !== ''"
            @click="confirmSelection"
          >
            Apply
          </btn-loading>
        </div>
      </div>
    </template>

    <sync-herotive-video-modal
      ref="open-sync-herotive-video-modal"
      :campaigns="campaigns"
      :current-ad-group="currentAdGroup"
      @fetchListVideo="fetchListVideoCreative"
    />
  </b-modal>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import {
  BModal,
  VBTooltip, BTab, BTabs, BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import BtnLoading from '@/layouts/components/BtnLoading.vue'
import Ripple from 'vue-ripple-directive'
import { toastification } from '@core/mixins/toast'
import SelectVideoCreativeLibrary
  from '@/views/campaign/components/duplicate/chooseVideo/SelectVideoCreativeLibrary.vue'
import SyncHerotiveVideoModal from '@/views/campaign/components/duplicate/chooseVideo/SyncHerotiveVideoModal.vue'
import SelectVideoTikTokView from './SelectVideoTikTokView.vue'

const { mapActions, mapGetters } = createNamespacedHelpers('campaign')

export default {
  components: {
    BFormInput,
    SyncHerotiveVideoModal,
    SelectVideoCreativeLibrary,
    BTabs,
    BTab,
    BtnLoading,
    BModal,
    vSelect,
    SelectVideoTikTokView,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mixins: [toastification],
  props: {
    campaigns: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      isTikTokPlacement: true,
      currentAdGroup: null,
      currentCampaignIndex: null,
      currentAdGroupIndex: null,
      selectedAd: null,
      selectedIdentity: null,
      destinationUrl: '',
      destinationUrls: {}, // Store destination URL for each ad
      isEditAdName: false,
      currentAdName: '',
      originalAdName: '',

      selectedVideos: [],
      selectedVideosTikTok: [],
      selectedVideosCreative: [],

      adOptions: [],
      identityOptions: [],
      hasMore: false,
      hasMoreCreative: false,
      loadingMore: false,
      loadingVideo: false,
      allVideos: [],
      allVideosCreative: [],
      allVideosLibrary: [],
      scrollPosition: 0, // Store scroll position for load more
      tempCreativeLists: {}, // Store temporary creative lists for each ad
      lastSelectedAdKey: null, // Track the previously selected ad key

      messageError: '',

      tab: '',

      currentPage: 1,
      isLibraryValid: true,
    }
  },

  computed: {
    ...mapGetters(['listIdentity', 'listVideoTikTok', 'listVideoCreative', 'listVideoLibrary', 'status', 'message', 'loading']),

    isValidLandingPageUrl() {
      if (this.hasLandingPageUrl && !this.destinationUrl) {
        return 'The landing page URL is required.'
        /* eslint-disable no-useless-escape */
      } if (!(/^(http[s]?:\/\/)(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/).test(this.destinationUrl)) {
        return 'The landing page URL is invalid.'
      }
      return ''
    },

    hasLandingPageUrl() {
      return !!this.selectedAd?.ad?.landingPageUrl
    },
  },

  watch: {
    $route: {
      immediate: true,
      async handler(val) {
        if (val && val.query?.advertiserId) {
          const params = {
            advertiserId: val.query?.advertiserId,
          }
          await this.getListIdentity(params)
          if (this.status) {
            this.identityOptions = this.listIdentity?.identity_list.map(identity => ({
              logo: identity.profile_image,
              name: identity.display_name,
              value: identity.identity_id || identity.header,
              bcId: identity.identity_authorized_bc_id,
              identityType: identity.identity_type,
            }))
          }
        }
      },
    },
  },

  methods: {
    ...mapActions(['getListIdentity', 'getListVideoTikTok', 'getListVideoCreative', 'getListVideoLibrary']),

    saveAdName() {
      if (!this.currentAdName.trim()) return

      if (this.selectedAd) {
        // Update the ad name in the selected ad
        this.selectedAd.name = this.currentAdName.trim()
        this.selectedAd.ad.adName = this.currentAdName.trim()

        // Update the ad name in the campaigns data
        if (this.currentAdGroup) {
          const { campaignIndex, adgroupIndex } = this.currentAdGroup
          const { adIndex } = this.selectedAd
          if (this.campaigns[campaignIndex]?.adgroupList[adgroupIndex]?.adList[adIndex]) {
            this.campaigns[campaignIndex].adgroupList[adgroupIndex].adList[adIndex].adName = this.currentAdName.trim()
          }
        }

        this.isEditAdName = false
        this.toastSuccess('Ad name updated successfully')
      }
    },

    cancelAdNameEdit() {
      this.currentAdName = this.originalAdName
      this.isEditAdName = false
    },

    startEditAdName() {
      if (this.selectedAd) {
        this.currentAdName = this.selectedAd.name || this.selectedAd.ad?.adName || ''
        this.originalAdName = this.currentAdName
        this.isEditAdName = true
      }
    },
    onLibraryValidationChange(isValid) {
      this.isLibraryValid = isValid
    },

    handleEnterDestinationUrl() {
      if (this.selectedAd?.value) {
        this.destinationUrls[this.selectedAd.value] = this.destinationUrl
      }
    },

    onClickTikTokTab() {
      this.tab = 'tiktok-posts'
      if (this.selectedVideosCreative.length > 0 && !this.isLibraryValid) {
        this.toastFailure('Please select Identity and enter Text before changing ads.')
      }
    },

    async initData() {
      this.loadingVideo = true
      if (this.currentAdGroup) {
        const { campaignIndex, adgroupIndex, adgroup } = this.currentAdGroup
        this.isTikTokPlacement = adgroup?.placements?.includes('PLACEMENT_TIKTOK')

        if (adgroup.adList) {
          this.adOptions = adgroup.adList.map((ad, adIndex) => ({
            campaignIndex,
            adgroupIndex,
            adIndex,
            ad,
            name: ad.adName,
            value: [campaignIndex, adgroupIndex, adIndex].join('-'),
          }))

          // eslint-disable-next-line prefer-destructuring
          this.selectedAd = this.adOptions[0]

          this.selectedVideos = this.selectedAd.ad.creativeList.map(creative => ({
            ...creative,
            ad_format: creative.creative_info?.ad_format,
            ad_text: creative.creative_info?.ad_text,
            identity_authorized_bc_id: creative.creative_info.identity_authorized_bc_id,
            identity_id: creative.creative_info.identity_id,
            identity_type: creative.creative_info.identity_type,
            item_id: creative.creative_info.item_id,
            image_info: creative.creative_info?.image_info || [],
            video_info: creative.creative_info?.video_info,
          })) || []

          this.destinationUrl = this.selectedAd.ad.landingPageUrl || ''

          this.selectedVideosTikTok = this.selectedVideos.filter(item => !item.video_info?.video_id)
          this.selectedVideosCreative = this.selectedVideos.filter(item => !!item.video_info?.video_id)

          if (this.isTikTokPlacement) {
            this.tab = 'tiktok-posts'
          } else {
            this.tab = 'creative-library'
          }

          const promises = []
          if (this.allVideos.length === 0 && this.isTikTokPlacement) {
            // eslint-disable-next-line prefer-destructuring
            const tiktokIdentity = this.identityOptions.filter(identity => identity.identityType !== 'CUSTOMIZED_USER') || []
            this.selectedIdentity = tiktokIdentity.find(identity => identity.value === this.selectedVideosTikTok.identity_id) || this.identityOptions[0]
            promises.push(this.getLoadMoreVideoTikTok())
          }
          if (this.allVideosCreative.length === 0) {
            promises.push(this.fetchListVideoCreative())
          }
          if (promises.length > 0) {
            await Promise.all(promises)
          }
        }

        this.lastSelectedAdKey = this.selectedAd.value
        this.tempCreativeLists[this.lastSelectedAdKey] = [...this.selectedVideos]
        this.destinationUrls[this.lastSelectedAdKey] = this.destinationUrl
      }

      this.loadingVideo = false
    },

    handleChangeAd(newSelected) {
      if (this.selectedVideosCreative.length > 0 && !this.isLibraryValid) {
        this.toastFailure('Please select Identity and enter Text before changing ads.')
        const revert = this.adOptions.find(opt => opt.value === this.lastSelectedAdKey)
        if (revert) this.selectedAd = revert
        return
      }
      if (this.lastSelectedAdKey) {
        const currentAd = this.adOptions.find(opt => opt.value === this.lastSelectedAdKey)
        const hasCurrentAdLandingPage = !!currentAd?.ad?.landingPageUrl
        if (hasCurrentAdLandingPage && !this.destinationUrl) {
          this.toastFailure('The landing page URL is required.')
          const revert = this.adOptions.find(opt => opt.value === this.lastSelectedAdKey)
          if (revert) this.selectedAd = revert
          return
        }
      }

      // Save current destination URL for the previous ad
      if (this.lastSelectedAdKey) {
        this.tempCreativeLists[this.lastSelectedAdKey] = [...this.selectedVideos]
        this.destinationUrls[this.lastSelectedAdKey] = this.destinationUrl
      }

      const adKey = newSelected?.value || this.selectedAd?.value

      // Load destination URL for the selected ad
      const targetAd = newSelected?.ad || this.selectedAd?.ad
      this.destinationUrl = this.destinationUrls[adKey] || targetAd?.landingPageUrl || ''

      if (this.tempCreativeLists[adKey]) {
        this.selectedVideos = [...this.tempCreativeLists[adKey]]
      } else {
        this.selectedVideos = (targetAd?.creativeList || []).map(creative => ({
          ...creative,
          ad_format: creative.creative_info?.ad_format,
          ad_text: creative.creative_info?.ad_text,
          identity_authorized_bc_id: creative.creative_info.identity_authorized_bc_id,
          identity_id: creative.creative_info.identity_id,
          identity_type: creative.creative_info.identity_type,
          item_id: creative.creative_info.item_id,
          image_info: creative.creative_info?.image_info || [],
          video_info: creative.creative_info?.video_info,
        }))
      }

      this.selectedVideosTikTok = this.selectedVideos.filter(item => !item.video_info?.video_id)
      this.selectedVideosCreative = this.selectedVideos.filter(item => !!item.video_info?.video_id)

      // Persist the current state for this ad key
      this.tempCreativeLists[adKey] = [...this.selectedVideos]

      this.lastSelectedAdKey = adKey
    },

    resetModal() {
      this.currentAdGroup = null
      this.currentCampaignIndex = null
      this.currentAdGroupIndex = null
      this.selectedAd = null
      this.destinationUrl = ''
      this.destinationUrls = {}
      this.isEditAdName = false
      this.currentAdName = ''
      this.originalAdName = ''

      this.selectedVideos = []
      this.selectedVideosTikTok = []
      this.selectedVideosCreative = []

      this.loadingMore = false
      this.loadingVideo = false
      this.scrollPosition = 0
      this.tempCreativeLists = {}
    },

    hideModal() {
      this.$refs['choose-video-modal'].hide()
      this.resetModal()
    },

    async showModal(campaignIndex, adgroupIndex) {
      // Set current ad group from passed parameters
      this.currentCampaignIndex = campaignIndex
      this.currentAdGroupIndex = adgroupIndex

      if (campaignIndex !== null && adgroupIndex !== null) {
        // Wait for campaigns to be loaded
        if (!this.campaigns || this.campaigns.length === 0) {
          // Show loading state and wait for campaigns to load
          this.loadingVideo = true
          this.$refs['choose-video-modal'].show()

          // Wait for campaigns to be available
          await this.waitForCampaigns()
        }

        const campaign = this.campaigns[campaignIndex]
        const adgroup = campaign?.adgroupList[adgroupIndex]

        this.currentAdGroup = {
          campaignIndex,
          adgroupIndex,
          adgroup,
        }
        this.initData()
      }

      this.$refs['choose-video-modal'].show()
    },

    async openSyncHerotiveVideoModal() {
      this.$refs['open-sync-herotive-video-modal'].showModal()
    },

    async waitForCampaigns() {
      const maxWaitTime = 10000 // 10 seconds
      const checkInterval = 100 // 100ms
      let waitTime = 0

      // eslint-disable-next-line no-await-in-loop
      while ((!this.campaigns || this.campaigns.length === 0) && waitTime < maxWaitTime) {
        // eslint-disable-next-line no-await-in-loop
        await new Promise(resolve => setTimeout(resolve, checkInterval))
        waitTime += checkInterval
      }

      return this.campaigns && this.campaigns.length > 0
    },

    async onIdentityChange(identity) {
      this.selectedIdentity = identity
      this.allVideos = []
      this.hasMore = false
      await this.getLoadMoreVideoTikTok()
    },

    async getLoadMoreVideoTikTok() {
      try {
        await this.fetchListVideoTikTok()
        let loopCount = 0
        const MAX_LOOP = 10

        while (this.allVideos.length < 8 && this.hasMore && loopCount < MAX_LOOP) {
          loopCount += 1
          // eslint-disable-next-line no-await-in-loop
          await this.fetchListVideoTikTok(true)
        }
      } catch (err) {
        this.toastFailure(err.data.message)
      }
    },

    async fetchListVideoTikTok(isLoadMore = false) {
      if (isLoadMore) {
        this.loadingMore = true
      } else {
        this.loadingVideo = true
      }

      const params = {
        advertiserId: this.$route.query?.advertiserId,
        identityId: this.selectedIdentity.value,
        identityType: this.selectedIdentity.identityType,
        identityAuthorizedBcId: this.selectedIdentity.bcId,
      }

      if (isLoadMore) {
        params.cursor = this.listVideoTikTok.cursor
      }

      await this.getListVideoTikTok(params)

      if (this.listVideoTikTok?.video_list) {
        if (isLoadMore) {
          this.allVideos = [...this.allVideos, ...this.listVideoTikTok.video_list]
        } else {
          this.allVideos = this.listVideoTikTok.video_list
        }

        this.hasMore = this.listVideoTikTok.has_more === true
      }

      if (isLoadMore) {
        this.loadingMore = false
      } else {
        this.loadingVideo = false
      }
    },

    async fetchListVideoCreative(isLoadMore = false) {
      if (isLoadMore) {
        this.currentPage += 1
        this.loadingMore = true
      } else {
        this.currentPage = 1
        this.loadingVideo = true
      }

      const params = {
        page: this.currentPage,
        size: 20,
        advertiserId: this.$route.query?.advertiserId,
      }

      await this.getListVideoCreative(params)

      if (this.listVideoCreative?.content) {
        const listVideo = this.listVideoCreative.content
        if (isLoadMore) {
          this.allVideosCreative = [...this.allVideosCreative, ...listVideo]
        } else {
          this.allVideosCreative = listVideo
        }
        this.hasMoreCreative = !!(this.listVideoCreative && this.listVideoCreative?.paging?.totalPage > this.currentPage)
      }

      if (isLoadMore) {
        this.loadingMore = false
      } else {
        this.loadingVideo = false
      }
    },

    getCreativeListsError() {
      const hasEmpty = Object.values(this.tempCreativeLists).some(list => list.length === 0)
      this.messageError = hasEmpty ? 'Please select at least one video for each ad.' : ''
    },

    toggleVideoSelection(listVideo) {
      if (this.tab === 'tiktok-posts') {
        this.selectedVideosTikTok = listVideo
      } else if (this.tab === 'creative-library') {
        this.selectedVideosCreative = listVideo
      }

      this.selectedVideos = [...this.selectedVideosTikTok, ...this.selectedVideosCreative]

      // Save current selection to temp storage per-ad
      if (this.lastSelectedAdKey) {
        this.tempCreativeLists[this.lastSelectedAdKey] = [...this.selectedVideos]
      }

      this.getCreativeListsError()
    },

    confirmSelection() {
      if (this.selectedVideosCreative.length > 0 && !this.isLibraryValid) {
        this.toastFailure('Please select Identity and enter Text before changing ads.')
        return
      }
      // Only validate landing page URL if current ad has landingPageUrl
      if (this.hasLandingPageUrl && this.isValidLandingPageUrl) {
        this.toastFailure(this.isValidLandingPageUrl)
        return
      }

      if (!this.selectedAd) return

      // Save current ad's creative list to temp storage before applying all changes
      if (this.lastSelectedAdKey) {
        this.tempCreativeLists[this.lastSelectedAdKey] = [...this.selectedVideos]
      }

      Object.keys(this.tempCreativeLists).forEach(adKey => {
        const [campaignIndex, adgroupIndex, adIndex] = adKey.split('-').map(Number)
        const creativeList = this.tempCreativeLists[adKey]

        if (this.campaigns[campaignIndex]?.adgroupList[adgroupIndex]?.adList[adIndex]) {
          const newCreativeList = creativeList.map(video => ({
            ...(video.ad_text && { ad_text: video.ad_text }),
            // eslint-disable-next-line no-underscore-dangle
            ...(video._id && { _id: video._id }),
            creative_info: {
              ...(video.ad_text && { ad_text: video.ad_text }),
              ad_format: video?.ad_format || 'SINGLE_VIDEO',
              identity_authorized_bc_id: video.identity_authorized_bc_id || '',
              identity_id: video.identity_id || '',
              identity_type: video.identity_type || '',
              ...(video.item_id && { item_id: video.item_id }),
              ...(video.image_info && { image_info: video.image_info }),
              ...(video.video_info && { video_info: video.video_info }),
            },
            ...(video.material_operation_status && { material_operation_status: video.material_operation_status }),
          }))
          this.campaigns[campaignIndex].adgroupList[adgroupIndex].adList[adIndex] = {
            ...this.campaigns[campaignIndex].adgroupList[adgroupIndex].adList[adIndex],
            ...(!!newCreativeList.find(item => item.ad_text) && { ad_text: newCreativeList.find(item => item.ad_text).ad_text }),
            ...(this.destinationUrls[adKey] && { landingPageUrl: this.destinationUrls[adKey] }),
            creativeList: newCreativeList,
          }
        }
      })

      this.hideModal()
    },
  },
}
</script>
<style lang="scss">
#choose-video-modal {
  .modal-content {
    height: 90vh;
    width: 1053px;
    margin: auto;

    .modal-body {
      height: 100%;
    }

    .form-control:focus, .input-group:focus-within .form-control {
      border-color: #e0e0e5 !important;
    }
  }

  .video-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 16px;
    margin-bottom: 20px;
  }

  .video-card {
    border: 2px solid #fff;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s ease;
    background: white;

    &:hover {
      border-color: #7367f0;
      box-shadow: 0 4px 12px rgba(115, 103, 240, 0.15);
    }

    &.selected {
      border-color: #7367f0;
      box-shadow: 0 4px 12px rgba(115, 103, 240, 0.25);
    }
  }

  .video-thumbnail {
    position: relative;
    width: 100%;
    height: 320px;
    overflow: hidden;

    .select-checkbox {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 24px;
      height: 24px;
      border-radius: 4px;
      border: 1px solid rgba(255, 255, 255, 0.9);
      background: rgba(0, 0, 0, 0.15);
      display: flex;
      align-items: center;
      justify-content: center;
      backdrop-filter: blur(2px);

      &.checked {
        background: #7367f0;
        border-color: #7367f0;
      }
    }

    .thumbnail-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .video-info {
    padding: 12px;

    .video-title {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.3;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .selection-summary {
    border: 1px solid #dee2e6;

    .selected-videos-list {
      max-height: 200px;
      overflow-y: auto;
    }

    .selected-video-item {
      padding: 8px 0;
      border-bottom: 1px solid #f1f1f1;

      &:last-child {
        border-bottom: none;
      }
    }

    .selected-thumbnail {
      width: 40px;
      height: 40px;
      object-fit: cover;
      border-radius: 4px;
    }
  }

  .select-video-input {
    .vs__selected-options {
      width: 88%;
      .vs__selected {
        width: 88%;
      }
    }
  }

  .hide-tab {
    .nav-tabs {display: none !important;}
  }

  .tab-video {
    .nav-tabs {
      border-bottom: 1px solid #eeeeee;
      p {
        margin-bottom: 0;
      }

      .nav-link.active {
        .selected-number {
          background-color: #e11c4e1a;
          color: #e11c4e;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.wrap-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.selected-number {
  background-color: #0000001a;
  color: #00000080;
  font-size: 12px;
  border-radius: 50%;
  width: 21px;
  height: 21px;
  margin-left: 8px;
}
</style>
